import React, { FC } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import clsx from "clsx";
import useI18n from "evcharging/hooks/useI18n";

interface RatesTabsProps {
  tabs: Array<{
    value: number,
    label: string,
  }>;
  value: number;
  onChange: (value: number) => void,
}

const RatesTabs: FC<RatesTabsProps> = (props) => {
  const { tabs, value, onChange } = props;
  const theme = useTheme();
  const classes = createStyles(theme);
  const onClick = (activeValue) => () => {
    onChange(activeValue);
  }

  return (
    <div className={classes.root}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={clsx(
            classes.tab,
            value === tab.value && classes.active
          )}
          onClick={onClick(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css({
      display: "flex",
      justifyContent: "space-between",
      padding: "0 16px",
      backgroundColor: "white",
      boxShadow: "0 3px 5px rgba(0, 0, 0, .05)",
      borderRadius: 6
    }),
    tab: css({
      color: theme.colors.text.middle,
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: `3px #fff solid`,
      background: 'none',
      fontWeight: "bold",
      fontSize: 14,
      textTransform: "capitalize",
      padding: 17
    }),
    active: css({
      color: theme.colors.accent,
      borderBottom: `3px ${theme.colors.accent} solid`,
    })
  }
);


export default RatesTabs;
